import BigNum from "../../model/math/BigNum";
import Vector from "../../model/math/Vector";
import SkillNode from "../../model/skillTree/SkillNode";
import NumberFormatter from "../../util/NumberFormatter";
import Page from "../framework/Page";
import View from "../framework/View";

export default class SkillNodeView extends View {
    /**
     * 
     * @param {string} parentId 
     * @param {SkillNode} node 
     */
    constructor(parentId, node) {
        super(parentId, parentId + '_' + node.id);

        /**
         * @constant
         * @type {SkillNode}
         */
        this.node = node;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;
        /**
         * @type {HTMLElement}
         */
        this.titleElement = null;
        /**
         * @type {string}
         */
        this.displayedTitle = null;
        /**
         * @type {HTMLElement}
         */
        this.descriptionElement = null;
        /**
         * @type {string}
         */
        this.displayedDescription = null;

        /**
         * @type {HTMLElement}
         */
        this.costElement = null;

        /**
         * @type {BigNum}
         */
        this.displayedCost = new BigNum(-10);

        /**
         * @constant
         * @type {Vector}
         */
        this.displayCoordinate = new Vector(0, 0);

        /**
         * @private
         * @type {number}
         */
        this.displayedPurchaseState = 0; // 0=not purchaseable, 1=purchaseable, 2=purchased

    }


    /**
     * @param {boolean} purchasable 
     * @param {boolean} purchased 
     * @returns {number}
     */
    getPurchaseStateValue(purchasable, purchased) {
        if (purchased) {
            return 2;
        }
        if (purchasable) {
            return 1;
        }
        return 0;
    }

    /**
     * @override
     */
    initializeView() {
        super.initializeView();

        // The upgrade view is dynamically created.
        const id = this.getElementId();
        const description = this.node.description;

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('SkillNodeView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'skill-tree-button-outer-not-purchasable');

        this.displayedPurchaseState = -1; // set to invalid value to force style update.

        const row1 = Page.createElement('div', this.mainElement, null, 'skill-tree-button-row1');

        ////////////////////////////////////////////////////////
        // Row:
        // [icon] [title      ] 
        // [    ] [cost       ]
        ////////////////////////////////////////////////////////

        // <img src="images/miner_icon_51x48.png"/>
        const imgElement = Page.createElement('img', row1, null, 'icon-container');  //'pick-upgrade-icon'
        imgElement.src = this.node.iconFileName;

        // Title/Cost container
        const titleDescriptionContainer = Page.createElement('div', row1, null, 'pick-upgrade-title-description-container');

        this.titleElement = Page.createElement('div', titleDescriptionContainer, null, null);
        this.titleElement.innerHTML = '';

        this.costElement = Page.createElement('div', titleDescriptionContainer, null, 'pick-upgrade-button-title-double-row'); // margin-top: 5px

        //////////////////////////////////////////////////////
        // Description row
        //////////////////////////////////////////////////////

        this.descriptionElement = Page.createElement('div', this.mainElement, null, 'skill-tree-button-description');
        this.descriptionElement.innerHTML = description;
        this.displayedDescription = description;

        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.mainElement.onclick = function() {
            if (!thisRef.node.isPurchasable()) {
                return;
            }

            thisRef.node.onPurchase(); 
        };

        this.setInitialVisibility(false);

        this.updatePosition();
    }
    
    /**
     * @override
     */
    updateView() {
        this.setViewVisible(this.node.nodeVisible);
        super.updateView();
    }

    /**
     * @override
     */
    updateViewContents() {

        this.updatePosition();

        const cost = this.node.getCost();
        const purchasable = this.node.isPurchasable();
        const purchased = this.node.purchased;

        const purchaseState = this.getPurchaseStateValue(purchasable, purchased);
        
        if (!cost.equals(this.displayedCost)) {
            this.displayedCost.copy(cost);
            this.costElement.innerHTML = NumberFormatter.formatBigNum(cost) + ' Prestige';
        }

        const title = this.node.getTitle();
        if (title !== this.displayedTitle) {
            this.displayedTitle = title;
            this.titleElement.innerHTML = title;
        }

        const description = this.node.getDescription();
        if (description !== this.displayedDescription) {
            this.displayedDescription = description;
            this.descriptionElement.innerHTML = description;
        }

        if (this.displayedPurchaseState !== purchaseState) {
            this.displayedPurchaseState = purchaseState;

            if (purchaseState === 0) {
                // purchaseState 0: not purchaseable
                this.mainElement.className = 'skill-tree-button-outer-not-purchasable';
            }
            else if (purchaseState === 1) {
                // purchaseState 1: purchaseable
                this.mainElement.className = 'skill-tree-button-outer';
            }
            else {
                // purchaseState 3: purchased
                this.mainElement.className = 'skill-tree-button-outer-purchased';
            }

        }
    }

    /**
     * @private
     */
    updatePosition() {
        if (this.displayCoordinate.equals(this.node.viewCoordinate)) {
            return;
        }
        this.displayCoordinate.copy(this.node.viewCoordinate);

        // The node viewCoordinate is updated each frame by SkillTreeView.updateViewContents()
        this.mainElement.style.left = this.node.viewCoordinate.x + 'px';
        this.mainElement.style.top = this.node.viewCoordinate.y + 'px';
    }

    //  border: 2px on each side
    //  padding: 5px on each size
    //  width: 180px
    //  actual width: 2 + 2 + 5 + 5 + 180 = 194
}